<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M45.17 54.46l-9.06-42.62c1.65-1.1 2.62-2.45 2.3-3.95-.22-1-1.12-2.34-4.15-2.73a20 20 0 00-6.57.41 20.33 20.33 0 00-6.17 2.29c-2.61 1.6-2.89 3.16-2.67 4.19s1 2.14 3.55 2.62l9.07 42.7a2 2 0 00.87 1.26 1.89 1.89 0 001.5.28l9.78-2.08a2 2 0 001.27-.83 2 2 0 00.28-1.54zM36.68 29l-8.32-.68-2.85-13.44a23.86 23.86 0 004-.51 24.76 24.76 0 003.78-1.12zM28.32 8.5c3.86-.82 6.36-.37 7.06 0-.48.66-2.58 2.09-6.44 2.91s-6.37.37-7.06 0c.47-.66 2.57-2.09 6.44-2.91zm5.88 47.27L29 31.35l8.32.69L42 54.11z"/></svg>